import Vue from "vue";
import Router from "vue-router";
import Shop from "./views/Shop.vue";
//import { setInterval } from "core-js";

//import store from './store.js'

window.$ = require("jquery");
window.JQuery = require("jquery");

// lazy-load
const OrderComplete = () =>
  import(
    /* webpackChunkName: "overview-activities" */ "./views/OrderComplete.vue"
  );

const OverviewActivities = () =>
  import(
    /* webpackChunkName: "overview-activities" */ "./views/OverviewActivities.vue"
  );

const OverviewPackages = () =>
  import(
    /* webpackChunkName: "overview-packages" */ "./views/OverviewPackages.vue"
  );

const Giftcard = () =>
  import(/* webpackChunkName: "giftcard" */ "./views/Giftcard.vue");

// Cart

const Cart = () => import(/* webpackChunkName: "cart" */ "./views/Cart.vue");

// Single Activity

const IndividualProductDetails = () =>
  import(
    /* webpackChunkName: "individual-product-details" */ "./views/individual/Details.vue"
  );

const IndividualStart = () =>
  import(
    /* webpackChunkName: "individual-product-details-start" */ "./views/individual/Start.vue"
  );

const Guests = () =>
  import(/* webpackChunkName: "product-details-guests" */ "./views/Guests.vue");
const PickupLocations = () =>
  import(
    /* webpackChunkName: "product-details-pickup" */ "./views/PickupLocations.vue"
  );
const AddOns = () =>
  import(/* webpackChunkName: "product-details-addons" */ "./views/AddOns.vue");

const LargeGuests = () =>
  import(
    /* webpackChunkName: "product-details-guests" */ "./views/LargeGuests.vue"
  );

const DatePicker = () =>
  import(
    /* webpackChunkName: "product-details-date" */ "./views/DatePicker.vue"
  );

// Packages

const PackageProductDetails = () =>
  import(
    /* webpackChunkName: "package-product-details" */ "./views/package/Details.vue"
  );

const PackageStart = () =>
  import(
    /* webpackChunkName: "package-product-details-start" */ "./views/package/Start.vue"
  );

// const PackageGuests = () =>
//   import(
//       /* webpackChunkName: "package-product-details-guests" */ "./views/package/Guests.vue"
//   );

Vue.use(Router);

/**
 * Router class
 *
 * @class Router
 */

export default new Router({
  mode: "history",
  //base: process.env.BASE_URL,
  base: "",
  routes: [
    // for old links from the previous version of the booking app
    {
      path: "/:client/shop/activities/:clientAgentKey",
      redirect: "/:client/activity/:clientAgentKey"
    },
    {
      path: "/:client/shop/activities",
      redirect: "/:client/activity"
    },
    {
      path: "/:client/shop/packages/:clientAgentKey",
      redirect: "/:client/package/:clientAgentKey"
    },
    {
      path: "/:client/shop/packages",
      redirect: "/:client/package"
    },
    {
      path: "/:client/details/:product/:id",
      redirect: "/:client/:product/details/:id/n/start"
    },
    {
      path: "/:client/details/:product/:id/:clientAgentKey",
      redirect: "/:client/:product/details/:id/:clientAgentKey/start"
    },

    // new routes

    //{ path: "/:client/complete", component: OrderComplete },

    {
      path: "/:client/complete",
      components: { app: OrderComplete },
      props: { checkout: false }
    },

    // {
    //   path: "/:client/cart",
    //   components: { app: Cart },
    //   props: { checkout: false }
    // },
    {
      path: "/:client/cart/:orderKey",
      components: { app: Cart },
      props: { checkout: false }
    },
    {
      path: "/:client/cart/:orderKey/:checkout",
      components: { app: Cart },
      props: { checkout: false }
    },

    //{ path: "/:client/giftcard", components: { app: Shop, overview: Giftcard } },
    { path: "/:client", redirect: "/:client/activity" },
    {
      path: "/:client",
      components: {
        app: Shop
      },
      children: [
        {
          path: "giftcard/:clientAgentKey",
          components: {
            overview: Giftcard
          }
        },
        {
          path: "giftcard",
          components: {
            overview: Giftcard
          }
        },
        {
          path: "giftcard/:modify/:id/:clientAgentKey",
          name: "giftcardModify",
          components: {
            overview: Giftcard
          }
        },
        {
          path: "activity/:clientAgentKey",
          components: {
            overview: OverviewActivities
          }
        },

        {
          path: "activity",
          components: {
            overview: OverviewActivities
          },
          children: [
            {
              path: ":modify/:id/:clientAgentKey",
              //path: ":modify",
              components: {
                details: IndividualProductDetails
              },
              children: [
                {
                  path: "start",
                  components: { detail_column: IndividualStart }
                },
                {
                  // will be rendered inside ProductDetails's <router-view>
                  // when /shop/packages is matched
                  path: "guests/:entityHierarchyKey",
                  components: { detail_column: Guests }
                },
                {
                  // will be rendered inside ProductDetails's <router-view>
                  // when /shop/packages is matched
                  path: "transportation/:entityHierarchyKey/:timeId",
                  components: { detail_column: PickupLocations }
                },
                {
                  // will be rendered inside ProductDetails's <router-view>
                  // when /shop/packages is matched
                  path: "addons/:entityHierarchyKey/:timeId",
                  components: { detail_column: AddOns }
                },
                {
                  // will be rendered inside ProductDetails's <router-view>
                  // when /shop/packages is matched
                  path: "large/:entityHierarchyKey/:timeId", // or time.Value
                  components: { detail_column: LargeGuests }
                },
                {
                  // will be rendered inside ProductDetails's <router-view>
                  // when /shop/packages is matched
                  path: "dates/:entityHierarchyKey",
                  components: { detail_column: DatePicker }
                }
              ]
            }
          ]
        },
        {
          // ShopPackages will be rendered inside Shop's <router-view>
          // when /shop/packages is matched
          path: "package/:clientAgentKey",
          components: {
            overview: OverviewPackages
          }
        },
        {
          // ShopPackages will be rendered inside Shop's <router-view>
          // when /shop/packages is matched
          path: "package",
          components: {
            overview: OverviewPackages
          },
          children: [
            {
              path: ":modify/:id/:clientAgentKey",
              //path: ":modify",
              components: {
                details: PackageProductDetails
              },
              children: [
                {
                  // will be rendered inside ProductDetails's <router-view>
                  // when /shop/packages is matched
                  path: "start",
                  components: { detail_column: PackageStart }
                },
                {
                  // will be rendered inside ProductDetails's <router-view>
                  // when /shop/packages is matched
                  path: "guests/:entityHierarchyKey",
                  components: { detail_column: Guests }
                },
                {
                  // will be rendered inside ProductDetails's <router-view>
                  // when /shop/packages is matched
                  path: "dates/:entityHierarchyKey",
                  components: { detail_column: DatePicker }
                },

                {
                  // will be rendered inside ProductDetails's <router-view>
                  // when /shop/packages is matched
                  path: "addons/:entityHierarchyKey/:timeId",
                  components: { detail_column: AddOns }
                },
                {
                  // will be rendered inside ProductDetails's <router-view>
                  // when /shop/packages is matched
                  path: "large/:entityHierarchyKey/:timeId", // or time.Value
                  components: { detail_column: LargeGuests }
                }
              ]
            }
          ]
        }
      ]
    }
  ]
});
